import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = [ 'target' ];

  toggle() {
    this.element.classList.toggle(this.targetClass);
  }
}
